<template>
    <li class="favorite favorite__list">
        <input
            v-if="updateMode && editable"
            type="radio"
            name="favorite"
            :value="favorite.id"
            @change="$emit('input', favorite.id)"
        />

        <a class="block flex gray-100 fs-3" href="#" @click="load">{{ favorite.name }}</a>

        <CompassMenu
            ref="refMenuActions"
            trigger="hover"
            placement="bottom-end"
            customClass="favorite-item__dropdown"
        >
            <CompassIconButton
                ref="settings"
                icon="action"
                size="small"
                class="favorite-item__dropdown-icon"
            />
            <template slot="dropdown">
                <CompassMenuItem
                    v-if="editable"
                    :label="$t.__('common.labels.settings')"
                    @click="$store.dispatch(`${listinghash}/editFavorite`, favorite)"
                />
                <CompassMenuItem
                    v-if="!editable"
                    :label="$t.__('common.labels.see')"
                    @click="$store.dispatch(`${listinghash}/editFavorite`, favorite)"
                />
                <CompassMenuItem
                    :id="`sharelink${favorite.id}`"
                    :label="$t.__('common.labels.share')"
                    @click="enableSharing"
                />
                <CompassMenuItem
                    v-if="!favorite.shortcut"
                    :label="$t.__('common.labels.set_as_shortcut')"
                    @click="addShortcut"
                />
                <CompassMenuItem
                    v-else
                    :label="$t.__('common.labels.remove_shortcut')"
                    @click="removeShortcut"
                />
                <CompassMenuItem
                    v-if="deletable"
                    :label="$t.__('common.labels.remove_favorite')"
                    @click="openDeleteModal"
                />
            </template>
        </CompassMenu>
    </li>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('user');

export default {
    props: {
        listinghash: {
            type: String,
            required: true,
        },
        favorite: {
            type: Object,
            required: true,
        },
        updateMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showSettingsActive: false,
        };
    },
    computed: {
        maxShortcuts() {
            return this.$store.state[this.listinghash].maxFavorites;
        },
        editable() {
            return (
                this.$store.state[this.listinghash].permissions.favorite &&
                this.userId == this.favorite.ownerid
            );
        },
        deletable() {
            return (
                this.$store.state[this.listinghash].permissions.favorite &&
                (this.userId == this.favorite.ownerid || this.isAdmin)
            );
        },

        shareUrl() {
            return this.$store.getters[`${this.listinghash}/favoriteSharedUrl`](this.favorite.id);
        },
        display() {
            return this.$store.state[this.listinghash].display;
        },

        ...mapState({
            userId: 'id',
            isAdmin: 'isAdmin',
        }),
    },

    methods: {
        openDeleteModal() {
            this.$confirm(
                this.$l10n.__('Confirmez-vous vouloir supprimer le filtre %(name)s ?', {
                    name: this.favorite.name,
                }),
                'Suppression du filtre favori',
                {
                    confirmButtonText: this.$l10n.__('Confirmer'),
                    cancelButtonText: this.$l10n.__('Annuler'),
                },
            ).then(() => {
                this.remove();
            });
        },
        onCopy() {
            Push.success(
                this.$l10n.__(
                    'Le lien à partager a été copié dans votre presse papier \n\n : %(link)s',
                    { link: this.shareUrl },
                ),
                '',
            );
        },
        onError() {
            Push.success(this.$l10n.__('Echec de copie du lien de partage'));
        },
        remove() {
            if (!this.deletable) {
                return;
            }

            SellsyJS.WebServiceCaller.del(
                `/favorites/${this.favorite.id}`,
                {},
                (response) =>
                    this.$store.commit(`${this.listinghash}/deleteFavorite`, response.favoriteId),
                (error) => Push.error(this.$l10n.__('Echec de la suppression de votre favori'), ''),
            );
        },

        load() {
            if (this.updateMode) {
                return;
            }

            let meta = {
                filters: this.favorite.filters,
                columns: this.favorite.columns,
            };

            this.$store.dispatch(`${this.listinghash}/resetFilters`, false);

            let listingFilters = this.$store.state[this.listinghash].filters;

            for (const filtername in this.favorite.filters) {
                let index = _.findIndex(listingFilters, { name: filtername });

                if (index != -1) {
                    let newfilter = listingFilters[index];
                    newfilter.active = true;
                    newfilter.data = this.favorite.filters[filtername];

                    this.$store.commit(`${this.listinghash}/applyFilter`, newfilter);
                }
            }
            if (this.favorite.layout) {
                // Columns
                let listingColumns = this.$store.state[this.listinghash].columns;
                var allcols = [];
                for (const key in listingColumns) {
                    // hide all columns
                    let col = listingColumns[key];
                    col.display = false;
                    allcols.push(col);
                }
                let rank = 0;
                for (const name in this.favorite.columns) {
                    let index = _.findIndex(allcols, { name: this.favorite.columns[name] });
                    if (index != -1) {
                        // and display allowed columns
                        allcols[index].display = true;
                        allcols[index].rank = rank++;
                    }
                }
                this.$store.commit(`${this.listinghash}/updateColumns`, allcols);
                // Sorting
                this.$store.commit(`${this.listinghash}/updateSorting`, {
                    direction: this.favorite.sort_direction,
                    field: this.favorite.sort_field,
                });
            }

            this.$store.dispatch(`${this.listinghash}/fetch`);
            this.$store.commit(`${this.listinghash}/updateFiltersView`, 'summary');

            this.$emit('load');
        },

        addShortcut() {
            SellsyJS.WebServiceCaller.post(
                `/favorites/${this.favorite.id}/shortcut`,
                {},
                {},
                (response) => {
                    Push.success(
                        this.$l10n.__(
                            'Raccourci créé pour votre favori, accédez-y directement depuis le panneau de filtres',
                        ),
                    );
                    this.updateShortcut(true);
                },
            );
        },

        removeShortcut() {
            SellsyJS.WebServiceCaller.del(
                `/favorites/${this.favorite.id}/shortcut`,
                {},
                (response) => {
                    Push.success(this.$l10n.__('Raccourci supprimé'));
                    this.updateShortcut(false);
                },
            );
        },

        updateShortcut(isShortcut) {
            this.favorite.shortcut = isShortcut;
            this.$store.commit(`${this.listinghash}/updateFavorite`, this.favorite);
        },

        copyUrlToClipboard() {
            this.$copyText(this.shareUrl).then(
                (e) => {
                    this.onCopy();
                },
                (e) => {
                    this.onError();
                },
            );
        },

        enableSharing() {
            if (this.favorite.shared) {
                this.copyUrlToClipboard();
                return;
            }

            SellsyJS.WebServiceCaller.patch(
                `/favorites/${this.favorite.id}/share`,
                {},
                {},
                (resonse) => {
                    this.$store.commit(`${this.listinghash}/updateFavorite`, {
                        ...this.favorite,
                        shared: true,
                    });
                    this.copyUrlToClipboard();
                },
            );
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.favorite {
    &__list {
        display: flex;
        align-items: center;
        padding: var(--spacing-0) var(--spacing-1);
        border-radius: 4px;
        word-break: break-all;
        hyphens: auto;

        &Settings {
            display: none;
            z-index: 10000;
        }

        &:hover {
            background-color: $primary-05;

            &Settings {
                display: block;
            }
        }

        &.no-settings {
            &Settings {
                display: none;
            }
        }
    }
}

.dropdown-shortcut {
    min-width: 220px;

    .to-shortcut {
        display: flex;
    }
}
</style>
